import rootStore from "@/app/store";
import crud, { ApiResponse } from "../crud";

export interface Plan {
  id: number;
  display_name: string;
  mask: number;
  office_count: number;
  location_count: number;
  price: number;
  public: boolean;
}

export interface PlanPermission {
  name: string;
  display_name: string;
  bit: number;
}

export function PlansAPI(baseUrl: string) {
  return {
    get: async (id: number) => {
      const businessProfileId =
        rootStore.getState().businessProfile.businessProfile.id;
      return (await crud.get(
        `${baseUrl}/plans/${id}?business_profile_id=${businessProfileId}`,
        undefined,
        true,
      )) as ApiResponse<Plan>;
    },
    list: async () => {
      const businessProfileId =
        rootStore.getState().businessProfile.businessProfile.id;
      return (await crud.get(
        `${baseUrl}/plans/?business_profile_id=${businessProfileId}`,
        undefined,
        true,
      )) as ApiResponse<Plan[]>;
    },
    getCurrent: async () => {
      const businessProfileId =
        rootStore.getState().businessProfile.businessProfile.id;
      return (await crud.get(
        `${baseUrl}/plans/current/?business_profile_id=${businessProfileId}`,
        undefined,
        true,
      )) as ApiResponse<Plan>;
    },
    permissions: async () => {
      const businessProfileId =
        rootStore.getState().businessProfile.businessProfile.id;
      return (await crud.get(
        `${baseUrl}/plans/permissions/?business_profile_id=${businessProfileId}`,
        undefined,
        true,
      )) as ApiResponse<PlanPermission[]>;
    },
  };
}
